import { ButtonFlavor, ButtonSize, ButtonType, ExButton, ExIcon } from '@boomi/exosphere';
import classNames from 'classnames';
import { useState } from 'react';
import { useApp } from '../common/AppProvider';
import { translations } from '../translations/translations';
import type { AlertPopup as AlertPopupType } from '../types/types';

interface Props {
    alert: AlertPopupType;
}

const AlertPopup = ({ alert }: Props) => {
    const { language, removeAlert } = useApp();
    const [showCopiedText, setShowCopiedText] = useState(false);
    const [currentTimeout, setCurrentTimeout] = useState<number>();

    const onCopy = () => {
        if (currentTimeout) {
            clearTimeout(currentTimeout);
        }
        setShowCopiedText(true);
        setCurrentTimeout(
            window.setTimeout(() => {
                setShowCopiedText(false);
            }, 3_000),
        );
        navigator.clipboard.writeText(
            alert.message + (alert.traceId ? `\nTrace Id: ${alert.traceId}` : ''),
        );
    };

    const classes = classNames('alert-popup', 'back-in-up', {
        hidden: alert.isRemoved,
        success: alert.type === 'success',
    });

    return (
        <div className={classes} id={`alert-${alert.id}`}>
            <div className="alert-popup-message">
                <p className="text md">{alert.message}</p>
                {alert.traceId && <p className="trace text sm">Trace Id: {alert.traceId}</p>}
            </div>
            {alert.traceId && (
                <ExButton
                    className="copy-action exo-button-action"
                    flavor={ButtonFlavor.BASE}
                    size={ButtonSize.LARGE}
                    type={ButtonType.SECONDARY}
                    onClick={onCopy}
                >
                    <ExIcon icon="Copy" hide-browser-tooltip />
                </ExButton>
            )}
            {alert.isPersistent && (
                <ExButton
                    data-testid="removeActionButton"
                    className="close-action exo-button-action"
                    flavor={ButtonFlavor.RISKY}
                    size={ButtonSize.LARGE}
                    type={ButtonType.PRIMARY}
                    onClick={() => removeAlert(alert.id)}
                >
                    <ExIcon icon="Close" hide-browser-tooltip />
                </ExButton>
            )}
            {showCopiedText && (
                <p className="copied text lg">{translations[language].ALERT_POPUP_copied}</p>
            )}
        </div>
    );
};

export default AlertPopup;
